export default "__VITE_ASSET__7fb0f0c4__"